<td-wb-modal-notification-header />

@if (currentTriggerId(); as triggerId) {
  <td-wb-modal-notification-content [triggerId]="triggerId" />
}

<td-wb-modal-notification-footer [step]="step()"
                                 [totalSubModals]="totalSubModals"
                                 (stepChange)="goToSelected($event)" />

